import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withStyles } from 'theme/withStyles';
import RawHtml from 'common/RawHtml';
import BottomContent from 'common/BottomContent';
import ErrorMsg from 'common/ErrorMsg';
import ButtonRowGroup from './common/ButtonRowGroup';

import commonStyles from './styles';

const styles = (theme) => {
  const common = commonStyles(theme);

  return {
    ...common,
    fields: {
      margin: '40px auto',
      maxWidth: 576,
      textAlign: 'justify',
    },
    root: {
      '& > hr': {
        display: 'none',
      },
      maxWidth: 'unset',
    },
  };
};

const DoneBare = ({
  bottomContent,
  children,
  classes,
  clientEmail,
  clientPhone,
  clientWeb,
  customerServiceLabel,
  emailLabel,
  hasFields,
  label,
  labelMobile,
  name,
  phoneLabel,
  resources,
  subText,
}) => (
  <>
    <div className={classnames('region-done-group', classes.root)}>
      <legend
        className={classnames('grp-label', classes.label)}
        role={!hasFields ? 'presentation' : undefined}
      >
        <RawHtml type="span" className={classnames('desktop', classes.desktopLabel)}>
          {label}
        </RawHtml>
        <RawHtml type="span" className={classnames('mobile', classes.mobileLabel)}>
          {labelMobile}
        </RawHtml>
      </legend>
      <RawHtml className={classnames('content', classes.content)}>{subText}</RawHtml>

      <ErrorMsg name={name} type="group" />

      {resources.content && <RawHtml>{resources.content}</RawHtml>}

      <hr />

      <div className={classnames('region-fields', classes.fields)}>{children}</div>

      <p className="center">
        <strong>{customerServiceLabel}</strong>
        <br />
        {phoneLabel} <RawHtml type="span">{clientPhone}</RawHtml>
        <br />
        {emailLabel} <RawHtml type="span">{clientEmail}</RawHtml>
        <br />
        <a href={clientWeb} target="_blank" rel="noopener noreferrer">
          {clientWeb}
        </a>
      </p>
    </div>

    <ErrorMsg name={name} type="group" />

    <BottomContent className="bottomContent">{bottomContent}</BottomContent>

    <ButtonRowGroup groupName={name} />
  </>
);

DoneBare.propTypes = {
  bottomContent: PropTypes.string,
  children: PropTypes.node,
  clientEmail: PropTypes.string,
  clientPhone: PropTypes.string,
  clientWeb: PropTypes.string,
  customerServiceLabel: PropTypes.string,
  emailLabel: PropTypes.string,
  hasFields: PropTypes.bool,
  label: PropTypes.string,
  labelMobile: PropTypes.string,
  name: PropTypes.string.isRequired,
  phoneLabel: PropTypes.string,
  resources: PropTypes.objectOf(PropTypes.string),
  subText: PropTypes.string,
};

DoneBare.defaultProps = {
  bottomContent: '',
  children: null,
  clientEmail: '',
  clientPhone: '',
  clientWeb: '',
  customerServiceLabel: 'Customer Service',
  emailLabel: 'Email:',
  hasFields: false,
  label: '',
  labelMobile: '',
  phoneLabel: 'Phone:',
  resources: {},
  subText: '',
};

const mapStateToProps = ({ groups, resources, session }, { name }) => {
  const group = groups[name];
  return {
    bottomContent: group.bottomContent,
    clientEmail: session.data.clientEmail,
    clientPhone: session.data.clientPhone,
    clientWeb: session.data.clientWeb,
    customerServiceLabel: resources.customerServiceLabel,
    emailLabel: resources.emailLabel,
    hasFields: group?.fields?.length > 0 ?? false,
    label: group.label,
    labelMobile: group.labelMobile,
    phoneLabel: resources.phoneLabel,
    resources: group.resources,
    subText: group.subText,
  };
};

const DoneStyled = withStyles(styles)(DoneBare);

export default connect(mapStateToProps)(DoneStyled);
